/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetVoicemailJudgmentResult200Response } from '../models';
/**
 * VoicemailJudgmentResultApi - axios parameter creator
 * @export
 */
export const VoicemailJudgmentResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 留守電判断結果取得API
         * @summary 留守電判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoicemailJudgmentResult: async (zoomPhoneResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'zoomPhoneResultId' is not null or undefined
            assertParamExists('getVoicemailJudgmentResult', 'zoomPhoneResultId', zoomPhoneResultId)
            const localVarPath = `/api/user/zoom_phone_results/{zoomPhoneResultId}/transcription/voicemail_judgment_result`
                .replace(`{${"zoomPhoneResultId"}}`, encodeURIComponent(String(zoomPhoneResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoicemailJudgmentResultApi - functional programming interface
 * @export
 */
export const VoicemailJudgmentResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoicemailJudgmentResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 留守電判断結果取得API
         * @summary 留守電判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoicemailJudgmentResult(zoomPhoneResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVoicemailJudgmentResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoicemailJudgmentResult(zoomPhoneResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VoicemailJudgmentResultApi - factory interface
 * @export
 */
export const VoicemailJudgmentResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoicemailJudgmentResultApiFp(configuration)
    return {
        /**
         * 留守電判断結果取得API
         * @summary 留守電判断結果取得API
         * @param {number} zoomPhoneResultId ZoomPhoneResult ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoicemailJudgmentResult(zoomPhoneResultId: number, options?: any): AxiosPromise<GetVoicemailJudgmentResult200Response> {
            return localVarFp.getVoicemailJudgmentResult(zoomPhoneResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VoicemailJudgmentResultApi - interface
 * @export
 * @interface VoicemailJudgmentResultApi
 */
export interface VoicemailJudgmentResultApiInterface {
    /**
     * 留守電判断結果取得API
     * @summary 留守電判断結果取得API
     * @param {number} zoomPhoneResultId ZoomPhoneResult ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailJudgmentResultApiInterface
     */
    getVoicemailJudgmentResult(zoomPhoneResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetVoicemailJudgmentResult200Response>;

}

/**
 * Request parameters for getVoicemailJudgmentResult operation in VoicemailJudgmentResultApi.
 * @export
 * @interface VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest
 */
export interface VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest {
    /**
     * ZoomPhoneResult ID
     * @type {number}
     * @memberof VoicemailJudgmentResultApiGetVoicemailJudgmentResult
     */
    readonly zoomPhoneResultId: number
}

/**
 * VoicemailJudgmentResultApi - object-oriented interface
 * @export
 * @class VoicemailJudgmentResultApi
 * @extends {BaseAPI}
 */
export class VoicemailJudgmentResultApi extends BaseAPI implements VoicemailJudgmentResultApiInterface {
    /**
     * 留守電判断結果取得API
     * @summary 留守電判断結果取得API
     * @param {VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailJudgmentResultApi
     */
    public getVoicemailJudgmentResult(requestParameters: VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest, options?: AxiosRequestConfig) {
        return VoicemailJudgmentResultApiFp(this.configuration).getVoicemailJudgmentResult(requestParameters.zoomPhoneResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
